import __request__ from "routing/request";
export function listNotifications(requestOptions) {
  return __request__("GET", "/system/notifications", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteNotification(notificationType, requestOptions) {
  return __request__("DELETE", `/system/notifications/${notificationType}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteKeyedNotification(notificationType, notificationKey, requestOptions) {
  return __request__("DELETE", `/system/notifications/${notificationType}/${notificationKey}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
